import React from 'react';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
}

/**
 * Layout component providing the insur_tale elevated card design pattern
 * Gray background with white content card floating with shadow
 */
const Layout: React.FC<LayoutProps> = ({ children, header }) => {
  return (
    <div className={styles.container}>
      {header && (
        <header className={styles.headerCard}>
          {header}
        </header>
      )}

      <main className={styles.mainCard}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
